import styled from "styled-components";
// import office_01 from "../../../assets/image/kanzlei/gallery/office_01.webp";
// import office_02 from "../../../assets/image/kanzlei/gallery/office_02.webp";
// import office_03 from "../../../assets/image/kanzlei/gallery/office_03.webp";
// import office_04 from "../../../assets/image/kanzlei/gallery/office_04.webp";
// import office_05 from "../../../assets/image/kanzlei/gallery/office_05.webp";
// import office_06 from "../../../assets/image/kanzlei/gallery/office_06.webp";
// import office_07 from "../../../assets/image/kanzlei/gallery/office_07.webp";
// import office_08 from "../../../assets/image/kanzlei/gallery/office_08.webp";
// import office_09 from "../../../assets/image/kanzlei/gallery/office_09.webp";
// import office_10 from "../../../assets/image/kanzlei/gallery/office_10.webp";
// import office_11 from "../../../assets/image/kanzlei/gallery/office_11.webp";
// import office_12 from "../../../assets/image/kanzlei/gallery/office_12.webp";
import office_new_3 from "../../../assets/image/kanzlei/gallery/office_new_3.jpg";
import office_new_2 from "../../../assets/image/kanzlei/gallery/office_new_2.jpg";
import office_new_1 from "../../../assets/image/kanzlei/gallery/office_new_1.jpg";
import Container from "../../UI/Container/Container";

const ItemWrapper = styled.div<{ slider?: boolean }>`
  ${({ slider }) =>
    !!slider ? "padding: 0 1rem;" : "width: calc(100% / 3 - 25px * 2 / 3);"}

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    ${({ slider }) =>
      !!slider ? "padding: 0 1rem;" : "width: calc(100% / 2 - 15px / 2);"}
  }
`;

const Gallery: React.FC<{ slider?: boolean }> = ({ slider = false }) => {
  const images = [office_new_1, office_new_2, office_new_3];

  const getItems = () => {
    return images.map((img, i) => (
      <ItemWrapper key={i} slider={slider}>
        <img
          src={img}
          alt=""
          className="max-w-full max-h-full object-cover aspect-square"
        />
      </ItemWrapper>
    ));
  };

  return (
    <Container>
      <div className="flex flex-wrap gap-[15px] md:gap-[25px] my-16">
        {getItems()}
      </div>
    </Container>
  );
};

export default Gallery;
